import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { getCountryCode, getMobileNumber } from '../../../Utils/Utility';

const LiveSupport = () => {
    const [url, setUrl] = useState("")
    const user = useSelector(state => state.amplifyUser.user);

    const phoneNumber = user?.attributes?.phone_number
    const cuid = user?.attributes?.sub
    const email = user?.attributes?.email
    const firstName = user?.attributes?.given_name
    const lastName = user?.attributes?.family_name


    useEffect(() => {
        const phone = getMobileNumber(phoneNumber);
        const countryCode = getCountryCode(phoneNumber);
        const baseUrl = process.env.REACT_APP_SUPPORT_URL
        const url = `${baseUrl}?type=user&cuid=${cuid}&email=${email}&firstName=${firstName}&lastName=${lastName}&phone=${phone}&countryCode=${countryCode}&apptype=FSWeb&supporttype=normal`;

        setUrl(url);

    }, []);

    return (
        <div className="content-page">
            <div className="content">
                <iframe
                    src={url}
                    style={{ width: '100%', height: '90vh', border: 'none' }}
                    title="Chat Support"
                />
            </div>
        </div>
    )
}

export default LiveSupport